import { useEffect, useState } from "react";
import { apiRequest } from "../api";
import { AsyncStatus, Button, Dialog, Field } from "../components";

interface BenefitPolicy { features: string[]; maxDevices: number; version: number; updatedAt: string; activeSubscribers: number }
export function AdminBenefitsWorkspace() {
  const [policy, setPolicy] = useState<BenefitPolicy | null>(null);
  const [features, setFeatures] = useState("");
  const [maxDevices, setMaxDevices] = useState("2");
  const [reason, setReason] = useState("");
  const [review, setReview] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  async function load() {
    setError("");
    try {
      const { policy: current } = await apiRequest<{ policy: BenefitPolicy }>("/api/admin/bomana/benefits");
      setPolicy(current); setFeatures(current.features.join("\n")); setMaxDevices(String(current.maxDevices));
    } catch (caught) { setError(caught instanceof Error ? caught.message : "无法读取全局权益"); }
  }
  useEffect(() => { void load(); }, []);
  const nextFeatures = [...new Set(features.split(/[\n,]/).map((value) => value.trim()).filter(Boolean))].sort();
  async function save() {
    if (!policy) return;
    setBusy(true); setError("");
    try {
      await apiRequest("/api/admin/bomana/benefits", { method: "PUT", body: JSON.stringify({
        features: nextFeatures, maxDevices: Number(maxDevices), expectedVersion: policy.version, reason,
      }) });
      setReview(false); setReason(""); setNotice("全局权益已更新，订阅时长保持不变；在线访问及凭据刷新采用新规则。");
      await load();
    } catch (caught) { setError(caught instanceof Error ? caught.message : "保存失败"); }
    finally { setBusy(false); }
  }
  return <article className="dashboard-card">
    <div className="section-heading"><div><span className="card-kicker">Bomana 订阅</span><h2>全局权益</h2></div><Button variant="secondary" onClick={() => void load()}>刷新权益</Button></div>
    <p>所有有效订阅使用同一套功能和设备规则。商品只决定价格与增加的时长。</p>
    {error ? <AsyncStatus tone="error">{error}</AsyncStatus> : notice ? <AsyncStatus tone="success">{notice}</AsyncStatus> : !policy ? <AsyncStatus tone="loading">正在读取全局权益…</AsyncStatus> : null}
    {policy ? <form onSubmit={(event) => { event.preventDefault(); setReview(true); }}>
      <p className="muted">当前版本 v{policy.version} · {policy.activeSubscribers} 位有效订阅用户 · {new Date(policy.updatedAt).toLocaleString("zh-CN")}</p>
      <Field label="统一功能" hint="每行一个功能标识；bomana.super_bomber 表示 Enhanced 完整功能。新增标识需对应客户端已支持的功能。">
        <textarea rows={4} value={features} onChange={(event) => setFeatures(event.target.value)} />
      </Field>
      <Field label="每位订阅用户的设备上限" hint="降低上限会限制新增绑定，已绑定设备不会被自动删除。">
        <input required type="number" min="1" max="100" value={maxDevices} onChange={(event) => setMaxDevices(event.target.value)} />
      </Field>
      <Field label="修改原因"><textarea required minLength={3} maxLength={500} rows={2} value={reason} onChange={(event) => setReason(event.target.value)} /></Field>
      <Button type="submit" disabled={reason.trim().length < 3}>预览全局变更</Button>
    </form> : null}
    {review && policy ? <Dialog open title="复核全局权益变更" description={`将应用于全部 ${policy.activeSubscribers} 位有效订阅用户，不改变任何订阅到期日。`} onClose={() => { if (!busy) setReview(false); }}
      footer={<><Button busy={busy} onClick={() => void save()}>确认更新所有订阅权益</Button><Button variant="secondary" disabled={busy} onClick={() => setReview(false)}>返回修改</Button></>}>
      <p>功能：{policy.features.join("、") || "无"} → {nextFeatures.join("、") || "无"}</p>
      <p>设备上限：{policy.maxDevices} → {maxDevices}</p><p>原因：{reason}</p>
      <p className="muted">已签发的离线凭据在原有效期内继续可用，刷新后采用新规则。</p>
      {error ? <p role="alert" className="form-error">{error}</p> : null}
    </Dialog> : null}
  </article>;
}
